import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  employmentType() {
    const options = [
      'FULL_TIME',
      'PART_TIME',
      'CONTRACTOR',
      'TEMPORARY',
      'INTERN',
      'VOLUNTEER',
      'PER_DIEM',
      'OTHER',
    ];

    return faker.helpers.arrayElements(options, 2);
  },

  headline() {
    return faker.name.jobTitle();
  },

  subHeadline() {
    return faker.name.jobArea();
  },

  text() {
    return faker.lorem.paragraphs(3);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(job, server) {
    job.update({
      asset: server.create('asset'),
      category: server.create('category', 'jobType'),
      division: server.create('division'),
      label: server.create('label'),
      link: server.create('link'),
      location: server.create('location'),
    });
  },
});
